import '../../../../../assets/vendor/swiper/swiper-bundle.js';

export default class Gallery{
    constructor($element) {
        this.$element = $element;
        this.effect = this.$element.dataset.galleryEffect ?
                this.$element.dataset.galleryEffect:
                'creative';

        new Swiper(this.$element , {
            slidesPerView: 1,
            speed: 400,
            grabCursor: true,
            autoHeight: true,
            effect: this.effect,
            loop: true,
            autoplay: {
                delay: 2000,
                pauseOnMouseEnter: true,
                disableOnInteraction: false,
            },
            pagination: {
                el: '.swiper-pagination',
                clickable: true,
                type: 'bullets',
            },
            navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
            },
            creativeEffect: {
                prev: {
                    shadow: true,
                    opacity: 0,
                    translate: [0, 0, -400],
                },
                next: {
                    translate: ["100%", 0, 0],
                },
            },
        });
    }
}